// @flow

export type Macro = {|
  macro: string,
  pattern: string,
  description: string,
  value: Function | string,
  hideInsertButton?: boolean,
|};

export const SPLIT_AT_MORE = 'listo/wysiwyg/SPLIT_AT_MORE';

export const splitAtMoreMacro: Macro = {
  macro: '<!--more-->',
  pattern: '(<!--more-->)',
  description: 'Toon een "lees meer" knop wanneer de Read More Tag wordt gebruikt',
  value: SPLIT_AT_MORE,
  hideInsertButton: true,
};
